import { createSlice } from "@reduxjs/toolkit";
import { verifyOrMarkSuspiciousUser } from "../../utils/apiCalls";

const {
  actions: {
    getDocumentLabelStart,
    getDocumentLabelSuccess,
    getDocumentLabelFailure,
    updateDocumentLabelStart,
    updateDocumentLabelComplete,
    createDocumentLabelStart,
    createDocumentLabelComplete,
    updateDocumentStart,
    updateDocumentComplete,
    getloyaltyLevelStart,
    getloyaltyLevelSuccess,
    getloyaltyLevelFailure,
    updateloyaltyLevelStart,
    updateloyaltyLevelComplete,
    getAllSABannersStart,
    getAllSABannersSuccess,
    getAllSABannersFailure,
    getAllAffiliateStart,
    getAllAffiliateSuccess,
    getAllAffiliateFailure,
    deleteSABannersStart,
    deleteSABannersSuccess,
    deleteSABannersFailure,
    uploadSABannerStart,
    uploadSABannerComplete,
    updateSABannerStart,
    updateSABannerComplete,
    updateSAUserStatusStart,
    updateSAUserStatusCompleted,
    updateSAUserStatusFailure,
    sendEmailStart,
    sendEmailCompleted,
    sendEmailFailure,
    getWelcomeBonusStart,
    getWelcomeBonusSuccess,
    getWelcomeBonusFailure,
    updateWelcomeBonusStart,
    updateWelcomeBonusComplete,
    updateWelcomeBonusFailuire,
    updateAffiliateStatusStart,
    updateAffiliateStatusComplete,
    updateAffiliateStatusFailuire,
    getBankingDetailsStart,
    getBankingDetailsSuccess,
    getBankingDetailsFailure,
    createBankingDetailsStart,
    createBankingDetailsComplete,
    createBankingDetailsFailure,
    updateBankingDetailsStart,
    updateBankingDetailsComplete,
    updateBankingDetailsFailure,
    deleteBankingDetailsStart,
    deleteBankingDetailsComplete,
    deleteBankingDetailsFailure,
    verifyOrMarkSuspiciousUserStart,
    verifyOrMarkSuspiciousUserCompleted,
    verifyOrMarkSuspiciousUserFailure,
    updateBankingDetailsStatusStart,
    updateBankingDetailsStatusComplete,
    updateBankingDetailsStatusFailure,
    updateBankingDetailsStatusOptimistic
  },
  reducer,
} = createSlice({
  name: "settings",
  initialState: {
    loading: false,
    documentLabels: null,
    loyaltyLevel: null,
    SABanners: null,
    deleteSAbanners: "",
    bonus: null,
    bankingDetails: null,
    affiliateRequests: null,
  },
  reducers: {
    getDocumentLabelStart: (state) => ({
      ...state,
      loading: true,
    }),
    getDocumentLabelSuccess: (state, { payload }) => ({
      ...state,
      loading: false,
      documentLabels: payload,
    }),
    getDocumentLabelFailure: (state) => ({
      ...state,
      loading: false,
    }),
    updateDocumentLabelStart: (state) => ({
      ...state,
      loading: true,
    }),
    updateDocumentLabelComplete: (state) => ({
      ...state,
      loading: false,
    }),
    createDocumentLabelStart: (state) => ({
      ...state,
      loading: true,
    }),
    createDocumentLabelComplete: (state) => ({
      ...state,
      loading: false,
    }),
    updateDocumentStart: (state) => ({
      ...state,
      loading: true,
    }),
    updateDocumentComplete: (state) => ({
      ...state,
      loading: false,
    }),
    getloyaltyLevelStart: (state) => ({
      ...state,
      loading: true,
    }),
    getloyaltyLevelSuccess: (state, { payload }) => ({
      ...state,
      loading: false,
      loyaltyLevel: payload,
    }),
    getloyaltyLevelFailure: (state) => ({
      ...state,
      loading: false,
    }),
    updateloyaltyLevelStart: (state) => ({
      ...state,
      loading: true,
    }),
    updateloyaltyLevelComplete: (state) => ({
      ...state,
      loading: false,
    }),
    getAllSABannersStart: (state) => ({
      ...state,
      loading: true,
    }),
    deleteSABannersStart: (state) => ({
      ...state,
      loading: true,
      deleteSAbanners: ""
    }),
    getAllSABannersSuccess: (state, { payload }) => ({
      ...state,
      loading: false,
      SABanners: payload,

    }),
    getAllSABannersFailure: (state) => ({
      ...state,
      loading: false,

    }),
    deleteSABannersSuccess: (state, { payload }) => ({
      ...state,
      loading: false,
      SABanners: payload,
      deleteSAbanners: payload
    }),
    deleteSABannersFailure: (state) => ({
      ...state,
      loading: false,
      deleteSAbanners: ""
    }),
    updateSABannerStart: (state) => ({
      ...state,
      loading: true,
    }),
    updateSABannerComplete: (state) => ({
      ...state,
      loading: false,
    }),
    uploadSABannerStart: (state) => ({
      ...state,
      loading: true,
    }),
    uploadSABannerComplete: (state) => ({
      ...state,
      loading: false,
    }),
    updateSAUserStatusStart: (state) => ({
      ...state,
      loading: true,
    }),
    updateSAUserStatusCompleted: (state, { payload }) => ({
      ...state,
      loading: false,
      SABanners: payload,
    }),
    updateSAUserStatusFailure: (state) => ({
      ...state,
      loading: false,
    }),
    verifyOrMarkSuspiciousUserStart: (state) => ({
      ...state,
      loading: true,
    }),
    verifyOrMarkSuspiciousUserCompleted: (state, { payload }) => ({
      ...state,
      loading: false,
    }),
    verifyOrMarkSuspiciousUserFailure: (state) => ({
      ...state,
      loading: false,
    }),
    sendEmailStart: (state) => ({
      ...state,
      loading: true,
    }),
    sendEmailCompleted: (state, { payload }) => ({
      ...state,
      loading: false,
      SABanners: payload,
    }),
    sendEmailFailure: (state) => ({
      ...state,
      loading: false,
    }),
    getWelcomeBonusStart: (state) => ({
      ...state,
      loading: true,
    }),
    getWelcomeBonusSuccess: (state, { payload }) => ({
      ...state,
      loading: false,
      bonus: payload,
    }),
    getWelcomeBonusFailuire: (state) => ({
      ...state,
      loading: false,
    }),
    updateWelcomeBonusStart: (state) => ({
      ...state,
      loading: true,
    }),
    updateWelcomeBonusComplete: (state, { payload }) => ({
      ...state,
      loading: false,
    }),
    updateWelcomeBonusFailuire: (state) => ({
      ...state,
      loading: false,
    }),
    getAllAffiliateSuccess: (state, { payload }) => ({
      ...state,
      loading: false,
      affiliateRequests: payload,
    }),
    getAllAffiliateStart: (state) => ({
      ...state,
      loading: true,
    }),
    getAllAffiliateFailure: (state) => ({
      ...state,
      loading: false,
    }),
    updateAffiliateStatusStart: (state) => ({
      ...state,
      loading: true,
    }),
    updateAffiliateStatusComplete: (state, { payload }) => ({
      ...state,
      loading: false,
    }),
    updateAffiliateStatusFailuire: (state) => ({
      ...state,
      loading: false,
    }),
    getBankingDetailsStart: (state) => ({
      ...state,
      loading: true,
    }),
    getBankingDetailsSuccess: (state, { payload }) => ({
      ...state,
      loading: false,
      bankingDetails: payload,
    }),
    getBankingDetailsFailure: (state) => ({
      ...state,
      loading: false,
    }),
    createBankingDetailsStart: (state) => ({
      ...state,
      loading: true,
    }),
    createBankingDetailsComplete: (state) => ({
      ...state,
      loading: false,
    }),
    createBankingDetailsFailure: (state) => ({
      ...state,
      loading: false,
    }),
    updateBankingDetailsStart: (state) => ({
      ...state,
      loading: true,
    }),
    updateBankingDetailsComplete: (state) => ({
      ...state,
      loading: false,
    }),
    updateBankingDetailsFailure: (state) => ({
      ...state,
      loading: false,
    }),
    updateBankingDetailsStatusStart: (state) => ({
      ...state,
    }),
    updateBankingDetailsStatusComplete: (state) => ({
      ...state,
      loading: false,
    }),
    updateBankingDetailsStatusFailure: (state, { payload }) => ({
      ...state,
      loading: false,
      bankingDetails: {
        ...state.bankingDetails,
        data: state.bankingDetails?.data?.map((bank) =>
          bank.bank_details_id === payload.bankDetailsId
            ? { ...bank, status: payload.previousStatus }
            : bank
        ) || []
      }
    }),
    updateBankingDetailsStatusOptimistic: (state, { payload }) => ({
      ...state,
      bankingDetails: {
        ...state.bankingDetails,
        data: state.bankingDetails?.data?.map((bank) => {
          return bank.bank_details_id === payload.bankDetailsId
            ? { ...bank, status: payload.newStatus }
            : bank;
        }) || []
      }
    }),
    deleteBankingDetailsStart: (state) => ({
      ...state,
      loading: true,
    }),
    deleteBankingDetailsComplete: (state) => ({
      ...state,
      loading: false,
    }),
    deleteBankingDetailsFailure: (state) => ({
      ...state,
      loading: false,
    }),
  },
});

export default reducer;

export {
  getDocumentLabelStart,
  getDocumentLabelSuccess,
  getDocumentLabelFailure,
  updateDocumentLabelStart,
  updateDocumentLabelComplete,
  createDocumentLabelStart,
  createDocumentLabelComplete,
  updateDocumentStart,
  updateDocumentComplete,
  getloyaltyLevelStart,
  getloyaltyLevelSuccess,
  getloyaltyLevelFailure,
  updateloyaltyLevelStart,
  updateloyaltyLevelComplete,
  getAllSABannersStart,
  getAllSABannersSuccess,
  getAllSABannersFailure,
  deleteSABannersStart,
  deleteSABannersSuccess,
  deleteSABannersFailure,
  uploadSABannerStart,
  uploadSABannerComplete,
  updateSABannerStart,
  updateSABannerComplete,
  updateSAUserStatusStart,
  updateSAUserStatusCompleted,
  updateSAUserStatusFailure,
  sendEmailStart,
  sendEmailCompleted,
  sendEmailFailure,
  getWelcomeBonusStart,
  getWelcomeBonusSuccess,
  getWelcomeBonusFailure,
  updateWelcomeBonusStart,
  updateWelcomeBonusComplete,
  updateWelcomeBonusFailuire,
  getAllAffiliateStart,
  getAllAffiliateSuccess,
  getAllAffiliateFailure,
  updateAffiliateStatusStart,
  updateAffiliateStatusComplete,
  updateAffiliateStatusFailuire,
  getBankingDetailsStart,
  getBankingDetailsSuccess,
  getBankingDetailsFailure,
  createBankingDetailsStart,
  createBankingDetailsComplete,
  createBankingDetailsFailure,
  updateBankingDetailsStart,
  updateBankingDetailsComplete,
  updateBankingDetailsFailure,
  deleteBankingDetailsStart,
  deleteBankingDetailsComplete,
  deleteBankingDetailsFailure,
  verifyOrMarkSuspiciousUserStart,
  verifyOrMarkSuspiciousUserCompleted,
  verifyOrMarkSuspiciousUserFailure,
  updateBankingDetailsStatusStart,
  updateBankingDetailsStatusComplete,
  updateBankingDetailsStatusFailure,
  updateBankingDetailsStatusOptimistic
};
